module.exports = __webpack_public_path__ + "static/media/Edit_icon.a3c0a18a.svg";